import { useMutation } from '@tanstack/react-query';
import { showSuccess, showError } from './toast';
import api from '../Services/api';
import { queryClient } from './queryClient';

export const useCreateData = (
  queryKeyToInvalidate: any[],
  successMessage = 'Criado com sucesso!'
) => {
  return useMutation({
    mutationFn: async ({
      endpoint,
      payload,
    }: {
      endpoint: string;
      payload: any;
    }) => {
      const { data } = await api.post(endpoint, payload);
      return data;
    },
    onSuccess: () => {
      // ✅ Invalida a query específica
      if (queryKeyToInvalidate && queryKeyToInvalidate.length > 0) {
        queryClient.invalidateQueries({
          queryKey: queryKeyToInvalidate,
          exact: false,
        });
      }
    },
    onError: (error: any) => {
      console.log('error', error);
      showError(
        error?.response?.data?.message || error?.message || 'Erro ao criar.'
      );
    },
  });
};